export const LogisticAsyncTaskEntityType = {
  Request: 'request',
  Reservation: 'reservation',
} as const;

export type LogisticAsyncTaskEntityType =
  (typeof LogisticAsyncTaskEntityType)[keyof typeof LogisticAsyncTaskEntityType];

export type LogisticAsyncTaskEntityReference =
  | {
      entityType: string;
      entityId: number;
    }
  | {
      entityType: null;
      entityId: null;
    };

/** Transport shape accepted by the generic logistics task publisher. */
export type LogisticAsyncTaskDefinition = LogisticAsyncTaskEntityReference & {
  type: string;
  stage: string;
  payload: unknown;
};

export enum LogisticAsyncTaskProducer {
  System = 'system',
  Outkeep = 'outkeep',
}

export type LogisticAsyncTaskError = {
  at: string;
  stage: string;
  attempt: number;
  kind: string;
  code?: string;
  message: string;
  incidentId?: string;
  workerInstanceId: string | null;
};
